import api from './axios';

export const adminLogin = (email, password) =>
  api.post('/auth/admin/login', { email, password });

// Veliler e-posta ile degil TELEFON ile giriyor (backend
// AuthController::parentLogin). Numara serbest bicimde gonderilebilir,
// sunucu 10 haneye normalize ediyor.
export const parentLogin = (phone, password) =>
  api.post('/auth/parent/login', { phone, password });

export const logout = () =>
  api.post('/auth/logout');

export const changePassword = (current_password, password, password_confirmation) =>
  api.post('/auth/change-password', { current_password, password, password_confirmation });

export const getMe = () =>
  api.get('/auth/me');